const slick = require('slick-carousel');

$(function () {
    window.configureProductSelectCarousels();
    window.configureAnimatedEgiftPreview();
    window.configureGroupHopperCarousel();

    $('#dropdownSelectedCardGroup').on('change', function () {
        $('#containerCardCarousel').fadeTo(250, 0.5);

        var url = $('#dropdownSelectedCardGroup').data('onchange-url') + '?productGroup=' + $(this).val();

        $.post(url, function (html) {
            $('#containerCardCarousel').closest('.carousel-container').find('.selected-product-id').val('');
            $('#containerCardCarousel').replaceWith(html);
            window.configureProductSelectCarousels();
            $('#containerCardCarousel .slick-current button').click();
            window.configureAnimatedEgiftPreview();
        });
    });
});

window.configureProductSelectCarousels = function () {

    $('.slick-carousel:not(.slick-initialized)').each(function () {

        const $carousel = $(this);

        var slidesToShow = window.options.slickOptions.slidesToShow;
        var slidesToScroll = window.options.slickOptions.slidesToScroll;

        if ($carousel.hasClass('wallet-carousel')) {
            if (window.options.slickOptions.slidesToShow_Wallet !== undefined) {
                slidesToShow = window.options.slickOptions.slidesToShow_Wallet;
            }
            if (window.options.slickOptions.slidesToScroll_Wallet !== undefined) {
                slidesToShow = window.options.slickOptions.slidesToScroll_Wallet;
            }
        }

        $carousel.on('init', function (slick) {
            selectCarouselItem($carousel);
        });

        $carousel.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: window.options.slickOptions.slidesToShow_Tablet,
                        slidesToScroll: window.options.slickOptions.slidesToScroll_Tablet
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: window.options.slickOptions.slidesToShow_Mobile,
                        slidesToScroll: window.options.slickOptions.slidesToScroll_Mobile
                    }
                }
            ],
            arrows: window.options.slickOptions.arrows
        });

        $carousel.on('click', '.image-container', function () {

            const $item = $(this);
            const productId = $item.data('product-id');
            selectCarouselItem($carousel, productId);
        });

        $carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            if (window.matchMedia("(max-width: 767px)").matches) {
                const currentCarouselItem = $carousel.closest('.carousel-container').find('[data-slick-index="' + currentSlide + '"]');
                var productId = currentCarouselItem.find('[data-product-id]').data('product-id')
                selectCarouselItem($carousel, productId);
            }
        });

        const slickIndex = $carousel.find('.image-container.selected').closest('.slick-slide').data('slick-index');
        if (slickIndex > 0) {
            $carousel.slick('slickGoTo', slickIndex);
        }

        hideShowExternalArrows();
    });
}

window.configureGroupHopperCarousel = function () {

    if ($(window).width() <= 750) {
        $('.group-hopper-carousel:not(.slick-initialized)').each(function () {

            const $carousel = $(this);

            $carousel.slick({
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1
            });

            const slickIndex = $carousel.find('.group.current').closest('.slick-slide').data('slick-index');
            if (slickIndex > 0) {
                $carousel.slick('slickGoTo', slickIndex);
            }
        });
    } else {
        $('.group-hopper-carousel.slick-initialized').each(function () {
            $(this).slick('unslick');
        });
    }

    
}

// HEM42-13648 - BT & Arnotts 
function hideShowExternalArrows() {
    if ($('.external-carousel-arrows').length > 0) {

        var checkSlidesToShow = window.options.slickOptions.slidesToShow;
        var slickSlides = $('.slick-slide:not(.slick-cloned)').length;

        if ($(window).width() < 992) {
            checkSlidesToShow = window.options.slickOptions.slidesToShow_Tablet;
        }

        if ($(window).width() < 768) {
            checkSlidesToShow = window.options.slickOptions.slidesToShow_Mobile;
        }

        if (slickSlides <= checkSlidesToShow) {
            $('.external-carousel-arrows').hide();
        } else {
            $('.external-carousel-arrows').show();
        }
    }
}

$(window).resize(function () {
    hideShowExternalArrows();
    configureGroupHopperCarousel();
});

function selectCarouselItem($carousel, productId) {

    const $productIdField = $carousel.closest('.carousel-container').find('.selected-product-id');

    if (productId === undefined) {
        productId = $productIdField.val();
    } else {
        $productIdField.val(productId);
    }

    var $selected = $carousel.find(`.image-container[data-product-id="${productId}"]`);

    if ($selected.length === 0) {
        $selected = $carousel.first('.image-container');
    }

    $carousel.find('.image-container').removeClass('selected');
    $selected.addClass('selected');

    handlePersonalisedImage($selected);
}

function handlePersonalisedImage($item) {

    if ($('#containerPersonalisedGift').length) {

        var isCustomisable = $item[0].hasAttribute('data-customisable');

        if (!isCustomisable) {
            $('#containerPersonalisedGift').hide();
            return;
        }

        var height = parseInt($item.data('custom-height'));
        var width = parseInt($item.data('custom-width'));
        var maxHeight = parseInt($item.data('max-height'));
        var maxWidth = parseInt($item.data('max-width'));
        var maxArea = maxWidth * maxHeight;
        var url = $item.data('customphoto-url');
        var aiGenerateUrl = $item.data('ai-generate-url');
        var aiFetchResultsUrl = $item.data('ai-fetchresults-url');
        var generationLimit = parseInt($item.data('ai-generation-limit'));
        var buttonGaps = generationLimit - 2;
        var submitUrl = $item.data('submitblob-url');

        $('#imgPersonalised').css('width', width + 'px');
        $('#imgPersonalised').closest('.personalised-image-container').find('.buttons').css('width', width + 'px');

        $('.ai-gallery-container').css('max-width', width + 'px');

        var galleryButtonWidth = width / generationLimit;   // Divide by the gallery limit here because there'll be 1 less buttons than the
        var galleryButtonHeight = height / generationLimit; // limit in the gallery, and the extra 1 will account for the spaces between them
        $('.ai-gallery-button').css('width', galleryButtonWidth + 'px');
        $('.ai-gallery-button').css('height', galleryButtonHeight + 'px');
        $('.ai-gallery-button:not(:last-of-type)').css('margin-right', galleryButtonWidth / buttonGaps + 'px'); // Divide by 2 less than the gallery limit because there's 1 less buttons than the limit in
        $('.ai-gallery-button').css('margin-bottom', galleryButtonHeight / buttonGaps + 'px');                  // the gallery so between them there'll 2 less spaces than the limit (make sense?)

        var loadingSpinnerOffsetLeft = (width - window.options.personalisationOptions.loadingSpinner.width) / 2;
        var loadingSpinnerOffsetTop = (height - window.options.personalisationOptions.loadingSpinner.height) / 2;
        $('#imgPersonalisedUploadLoadingSpinner').css('left', loadingSpinnerOffsetLeft);
        $('#imgPersonalisedUploadLoadingSpinner').css('top', loadingSpinnerOffsetTop);

        $('#containerPersonalisedGift').show();

        $('#buttonSelectAiMode').off('click');
        $('#buttonSelectAiMode').on('click', function () {
            var gallery = $('#imgPersonalised').data('ai-gallery-on-reset');

            if (gallery !== undefined && gallery.length) {
                $('#imgPersonalised').removeData('ai-gallery-on-reset');

                $('#imgPersonalisedUploadLoadingSpinner').show();

                $('#inputUploadedImage').prop('disabled', true);
                $('#containerPersonalisedGift .upload-button').prop('disabled', true);
                $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', true);

                var current = gallery.find((item) => item.isCurrent === true);
                populateAiGallery(gallery, current?.url);
            }

            $('.form-group.ai-prompt').addClass('is-current');
            $('#containerPersonalisedGift').addClass('is-ai-mode');
            $('#hiddenPersonalisedGiftSource').val('AI_PROMPT');

            var $carousel = $('.ai-style-buttons-carousel');

            $carousel.slick({
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });

            $carousel.find('.slick-prev').css('background-image', 'url("' + $carousel.data('prev-img') + '")');
            $carousel.find('.slick-next').css('background-image', 'url("' + $carousel.data('next-img') + '")');
        });

        $('#buttonGenerateAiImage').off('click');
        $('#buttonGenerateAiImage').on('click', function () {
            var prompt = $('#inputAiPrompt').val();
            var style = $('#selectAiStyle').val()

            if (prompt === '') {
                return;
            }

            $('#inputAiPrompt-error, #inputAiPrompt-throttled').hide();
            $('#inputAiPrompt').removeClass('is-invalid').removeClass('is-valid');
            $('#inputUploadedImage').prop('disabled', true);
            $('#containerPersonalisedGift .upload-button').prop('disabled', true);
            $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', true);

            $('#imgPersonalisedUploadLoadingSpinner').show();

            $.ajax({
                url: aiGenerateUrl,
                type: 'POST',
                cache: false,
                data: {
                    prompt: prompt,
                    style: style,
                    width: $('[data-product-id].selected').data('custom-width'),
                    height: $('[data-product-id].selected').data('custom-height')
                },
                success: function (result) {
                    console.info(result);

                    if (result.success) {
                        pollFetchAiImageResults(result.currentId);
                    } else {
                        if ($('#imgPersonalised').data('is-placeholder') && result.gallery !== undefined) {
                            var current = result.gallery.find((item) => item.isCurrent === true);
                            populateAiGallery(result.gallery, current?.url);
                        }

                        $('#inputAiPrompt-error').text(result.message);
                        $('#inputAiPrompt-error').show();
                        $('#inputAiPrompt').addClass('is-invalid').removeClass('is-valid');

                        $('#inputUploadedImage').prop('disabled', false);
                        $('#containerPersonalisedGift .upload-button').prop('disabled', false);
                        $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('#imgPersonalisedUploadLoadingSpinner').hide();
                    $('#inputUploadedImage').prop('disabled', false);
                    $('#containerPersonalisedGift .upload-button').prop('disabled', false);
                    $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);

                    if (xhr.status === 409) {
                        // 409 (Conflict) indicates request was throttled
                        $('#inputAiPrompt-throttled').show();
                        $('#inputAiPrompt').addClass('is-invalid').removeClass('is-valid');
                    }
                }
            });
        });

        $('#inputAiPrompt').off('keydown');
        $('#inputAiPrompt').on('keydown', function (event) {
            if (event.key == 'Enter') {
                event.preventDefault();
                $("#buttonGenerateAiImage").trigger('click');
                return false;
            }
        });

        $('#inputUploadedImage').off('change');
        $('#inputUploadedImage').on('change', function () {

            if ($('.ai-style-buttons-carousel').hasClass('slick-initialized')) {
                $('.ai-style-buttons-carousel').slick('unslick');
            }
            $('.form-group.ai-prompt').removeClass('is-current');
            $('#containerPersonalisedGift').removeClass('is-ai-mode');
            $('#hiddenPersonalisedGiftSource').val('IMAGE_UPLOAD');

            var file = $('#inputUploadedImage')[0].files[0];

            if (file.size > 10485760) { // 10MB, to match IIS request limit
                $('#inputUploadedImage-validation-error-too-large').show();
                return;
            } else {
                $('#inputUploadedImage-validation-error-too-large').hide();
            }

            getImageDimensions(file).then(dimensions => {
                if (dimensions.area > maxArea) {
                    $('#inputUploadedImage-validation-error-dimensions').show();
                    return;
                } else {
                    $('#inputUploadedImage-validation-error-dimensions').hide();
                }

                $('#inputUploadedImage').prop('disabled', true);
                $('#containerPersonalisedGift .upload-button').prop('disabled', true);
                $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', true);

                $('#imgPersonalisedUploadLoadingSpinner').show();

                var fd = new FormData();
                fd.append('file', file);

                $.ajax({
                    url: url,
                    type: 'POST',
                    cache: false,
                    data: fd,
                    processData: false,
                    contentType: false,
                    success: function (result) {
                        $('#imgPersonalisedUploadLoadingSpinner').hide();
                        if (result.success) {
                            $('#inputUploadedImage-validation-error').hide();
                            initCroppie(result.url);
                        } else {
                            $('#inputUploadedImage-validation-error').text(result.error);
                            $('#inputUploadedImage-validation-error').show();
                        }
                    },
                    error: function () {
                        $('#inputUploadedImage').prop('disabled', false);
                        $('#containerPersonalisedGift .upload-button').removeAttr('disabled');
                        $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                    }
                });
            });
        });

        $('#buttonFinaliseCrop').off('click');
        $('#buttonFinaliseCrop').on('click', function () {
            window.finaliseCropForPersonalisedGift();
        });

        $('#buttonClearPersonalisedImage').off('click');
        $('#buttonClearPersonalisedImage').on('click', function () {
            $('#inputPermissionCheck').attr('checked', false);
            $('#inputPrivacyCheck').attr('checked', false);
            $.ajax({
                url: $('#buttonClearPersonalisedImage').data('clearphoto-url'),
                type: 'POST',
                cache: false,
                success: function (result) {
                    console.info(result);
                    $('#imgPersonalised').attr('src', $('#buttonClearPersonalisedImage').data('placeholder-image-src'));
                    $('#imgPersonalised').data('is-placeholder', true);
                    $('#imgPersonalised').data('ai-gallery-on-reset', result.gallery);
                    resetCroppie();
                    $('#buttonClearPersonalisedImage').prop('disabled', true);
                    $('#inputUploadedImage').val('');
                    $('#inputUploadedImage').prop('disabled', false);
                    $('#inputAiPrompt').val('');
                    $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                    $('#containerPersonalisedGift .upload-button').removeAttr('disabled');
                }
            });
        });

        $('.ai-gallery-button').off('click');
        $('.ai-gallery-button').on('click', function () {
            var galleryId = $(this).data('gallery-id');

            if (galleryId === undefined) {
                return;
            }

            $('#imgPersonalisedUploadLoadingSpinner').show();

            $('#inputUploadedImage').prop('disabled', true);
            $('#containerPersonalisedGift .upload-button').prop('disabled', true);
            $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', true);

            pollFetchAiImageResults(galleryId);
        });

        function pollFetchAiImageResults(currentId) {
            $.ajax({
                url: aiFetchResultsUrl,
                type: 'POST',
                cache: false,
                data: { id: currentId },
                success: function (result) {
                    console.info(result);

                    if (result.success) {
                        if (result.complete) {
                            populateAiGallery(result.gallery, result.outputUrl);
                        } else {
                            setTimeout(function () {
                                pollFetchAiImageResults(currentId);
                            }, 1500);
                        }
                    } else {
                        $('#imgPersonalisedUploadLoadingSpinner').hide();

                        $('#inputAiPrompt-error').text(result.message);
                        $('#inputAiPrompt-error').show();
                        $('#inputAiPrompt').addClass('is-invalid').removeClass('is-valid');

                        $('#inputUploadedImage').prop('disabled', false);
                        $('#containerPersonalisedGift .upload-button').prop('disabled', false);
                        $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                    }
                },
                error: function () {
                    $('#inputUploadedImage').prop('disabled', false);
                    $('#containerPersonalisedGift .upload-button').prop('disabled', false);
                    $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                }
            });
        }

        function initCroppie(imageUrl) {

            $('#imgPersonalised').attr('src', imageUrl);
            $('#inputUploadedImage-validation-error-required').hide();
            $('#imgPersonalised').data('is-placeholder', false);

            var viewportWidth = width;
            var viewportHeight = height;
            var boundary = 30;
            var gutter = 30;

            var requiredSpace = viewportWidth + boundary + gutter;

            if (requiredSpace > window.innerWidth) {
                var scale = window.innerWidth / viewportWidth;
                viewportWidth = viewportWidth * scale - boundary - gutter;
                viewportHeight = viewportHeight * scale - boundary - gutter;
            }

            window.croppie = new window.Croppie(document.getElementById('imgPersonalised'), {
                viewport: { width: viewportWidth, height: viewportHeight },
                boundary: { width: viewportWidth + boundary, height: viewportHeight + boundary }
            });

            $('#buttonFinaliseCrop').prop('disabled', false);
            $('#buttonClearPersonalisedImage').prop('disabled', false);
        }

        window.resetCroppie = function () {
            if (window.croppie !== null && window.croppie !== undefined) {
                window.croppie.destroy();
                window.croppie = null;
            }

            $('#buttonFinaliseCrop').prop('disabled', true);
        }

        window.selectFacebookImageForPersonalisedGift = function (source) {

            $.ajax({
                url: url,
                type: 'POST',
                cache: false,
                data: { imageUrl: source },
                success: function (result) {
                    if (result.success) {
                        initCroppie(result.url);
                    }
                }
            });
        }

        window.finaliseCropForPersonalisedGift = function (callback) {
            if (window.croppie === null) {
                if (callback !== undefined) {
                    callback();
                }
                return;
            }
            window.croppie.result({
                type: 'blob',
                size: 'original',
                quality: 1
            }).then(function (blob) {
                submitPersonalisedGiftBlob(blob, callback);
            });
        }

        function submitPersonalisedGiftBlob(blob, callback) {
            var width = $('[data-product-id].selected').data('custom-width');
            var height = $('[data-product-id].selected').data('custom-height');

            var fd = new FormData();
            fd.append('file', blob);
            fd.append('resize', true);
            fd.append('width', width);
            fd.append('height', height);

            $.ajax({
                url: submitUrl,
                type: 'POST',
                cache: false,
                data: fd,
                processData: false,
                contentType: false,
                success: function (result) {
                    if (result.success) {
                        $('#imgPersonalised').attr('src', result.base64Src);
                        window.resetCroppie();

                        if (callback !== undefined) {
                            callback();
                        }
                    } else {
                        console.error(result.error);
                    }
                },
                complete: function () {
                    $('#imgPersonalisedUploadLoadingSpinner').hide();
                }
            });
        }

        function populateAiGallery(gallery, currentUrl) {
            $('.ai-gallery-button').html('');
            $('.ai-gallery-button').removeData('gallery-id');

            var buttonIndex = 1;
            for (let i = 0; i < gallery.length; ++i) {
                if (!gallery[i].isCurrent) {
                    $('#buttonAiGallery' + buttonIndex).html('<img src="' + gallery[i].url + '" />');
                    $('#buttonAiGallery' + buttonIndex).data('gallery-id', gallery[i].id);
                    $('#buttonAiGallery' + buttonIndex).addClass('is-populated');
                    buttonIndex++;
                }
            }

            if (currentUrl === undefined || currentUrl === '') {
                return;
            }

            fetch(currentUrl)
                .then(response => response.blob())
                .then(blob => {
                    $('#imgPersonalised').attr('src', currentUrl);
                    $('#inputUploadedImage-validation-error-required').hide();
                    $('#imgPersonalised').data('is-placeholder', false);

                    submitPersonalisedGiftBlob(blob);

                    $('#inputUploadedImage').prop('disabled', false);
                    $('#containerPersonalisedGift .upload-button').prop('disabled', false);
                    $('#inputAiPrompt, #buttonGenerateAiImage, #selectAiStyle, .ai-style-button').prop('disabled', false);
                });
        }

        window.getImageDimensions = function (file) {
            var dataURL = window.URL.createObjectURL(file);

            return new Promise(resolve => {
                var img = new Image();
                img.onload = function () {
                    resolve({
                        height: img.height,
                        width: img.width,
                        area: img.width * img.height
                    });
                };
                img.src = dataURL;
            });
        }

        window.selectAiStyle = function (style) {
            $('#selectAiStyle').val(style);
            $('.ai-style-button').removeClass('is-current');
            $('.ai-style-button[data-ai-style="' + style + '"]').addClass('is-current');
        }
    }
}
